import React, { useState } from 'react'
import FilterData from './FilterData'
import useAuth from '../hooks/useAuth.js';
import SearchBar from './SearchBar';
//import Sidebar from './Sidebar';

function Filter() {
  const { auth } = useAuth();
  const [searchValue,setSearchValue] = useState('');
  return (
    <div>
    <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[20px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} -Filter</h2>
    <div>
      <div >
        <FilterData searchValue={searchValue}/>
      </div>
    </div>
    </div>
  )
}

export default Filter
